import {useTranslation} from "react-i18next";
import {useTheme} from "@material-ui/core/styles";
import AccordionItem from "../AccordionItem";
import {chooseColor, filterByHIXCLIXFleschLangLevel, getScale, getValue, roundWithPrecision} from "../../../../../utils";
import AccordionModalDefault from "../AccordionModal/AccordionModalDefault";
import React from "react";
import {useSelector} from "react-redux";
import config from "../../../../../config";

// fullCountBase
export default function Experimental({
                                        showedValues,
                                        handleModalAccordionOpen,
                                        handleTopAccordionOpen,
                                        handleOnPopupClick,
                                        getNextPopup,
                                        index,
                                        filter
                                    }) {
    const {t} = useTranslation();
    const {theme: {colors}} = useTheme();

    const themeColors = {
        red: colors.colorProgress20,
        yellow: colors.colorProgress60,
        green: colors.colorProgress100,
        blue: colors.colorProgress120
    };

    const resultData = useSelector(state => state.analyseData.result.resultData);
    const currentBenchmarkSettings = useSelector(state => state.analyseData.result.benchmark);
    const languageLevelData = resultData?.dataLanguageLevel || {}

    let topColor = 'green';
    let num = 0


    const cells = showedValues.reduce((acc, valueName) => {
        const countNumber =resultData[valueName].length;


        const localSettings = currentBenchmarkSettings?.settings[valueName]?.values;
        const localTarget = getValue(localSettings, "target", 50);
        const localThreshold = getValue(localSettings, "threshold", 50);
        const localTargetYellowGreen = getValue(localSettings, "yellowGreen", 50);
        const localTargetYellowRed = getValue(localSettings, "yellowRed", 50);
        const localScaleFrom = getValue(localSettings, "scaleFrom", 0);
        const localScaleTo = getValue(localSettings, "scaleTo", 100);
        const fullValueCount = config.fullCountBase[valueName] !== undefined ? config.fullCountBase[valueName] : "countWords";

        const localPercent = countNumber / (resultData[fullValueCount] / 100);
        const localColor = chooseColor(localPercent, localTargetYellowGreen, localTargetYellowRed);

        // convert real % into  scale size percent
        const [scalePercent, targetPercent] = getScale (localPercent, localTarget, localScaleFrom, localScaleTo);

        // if filter = ignore
        if (!filter[localColor])
            return [...acc];

        // cilx + hix filter
        if (filterByHIXCLIXFleschLangLevel(filter, currentBenchmarkSettings?.settings[valueName]?.values?.clix, valueName, languageLevelData[valueName] !== undefined))
            return [...acc];

        num += countNumber;
        topColor = localColor === 'red' ? 'red' : (localColor === 'yellow' && topColor !== 'red') ? 'yellow' : topColor;

        return [
            ...acc,
            {
                toolTip: t('experimental_' + valueName + '_tooltip'),
                colorBar: themeColors[localColor],
                colorTop: themeColors[localColor],
                cellColor: localColor,
                id: 'Experimental_' + valueName,
                num: roundWithPrecision(countNumber, 0),
                target: localTarget,
                targetTriangle: targetPercent,
                actual: roundWithPrecision(localPercent, 1),
                scaleWidth: roundWithPrecision(scalePercent, 1),
                title: t(valueName, {threshold: localThreshold})
            }
        ]
    }, []);

    //const percent = num / (resultData.countWords / 100);

    if (cells.length === 0)
        return null;

    return (
        <AccordionItem
            color={themeColors[topColor]}
            topColor={topColor}
            number={num}
            title={t("Experimental")}
            index={index}
            handleTopAccordionOpen={handleTopAccordionOpen}
            windowsKey={'Experimental'}
        >
            <AccordionModalDefault
                handleOnPopupClick={handleOnPopupClick}
                getNextPopup={getNextPopup}
                handleModalAccordionOpen={handleModalAccordionOpen}
                cells={cells}
                windowsKey={'Experimental'}
            />
        </AccordionItem>
    );
}